"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const IpiNumberToolTip = () => (react_1.default.createElement(CustomToolTip_1.default, { type: '?', info: react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("p", null, "If you have a Publisher IPI (Interested Party Identifier), enter it here. If not, leave this field blank."),
        react_1.default.createElement("p", null, "If you've established your publisher at a PRO, they will have information about your IPI.")) }));
exports.default = IpiNumberToolTip;
